import { render, staticRenderFns } from "./PatientInsuranceBanner.vue?vue&type=template&id=7a4b9212&"
import script from "./PatientInsuranceBanner.vue?vue&type=script&lang=js&"
export * from "./PatientInsuranceBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports